<template>
  <div>
      <div class="box mb-3">
        <div class="columns">
          <div
            class="column px-0 py-0 image is-full-mobile is-one-quarter-tablet"
          >            

            <img
              :src="image"
              style="object-fit:cover;max-height:150px"
              class="property_image"
            />            

          </div>
          <div class="column is-one-half-mobile">
            <div class="is-size-5 has-text-black" data-test="hotel_result_name">
              {{ solution.hotelName }}
            </div>
            <!-- <star-rating :star-size="20"  :show-rating="false" :maxRating="solution.stars" :rating="solution.stars" :read-only="true" :increment="1"></star-rating> -->
              <div class="is-size-7 has-text-grey">
                {{ solution.address.AddressLine }}

                <a
                  data-test="hotel_result_proximity"
                  @click="
                    goToMaps(
                      solution.coordinates.latitude,
                      solution.coordinates.longitude
                    )
                  "
                >
                  <b-icon icon="map-marker" size="is-small"></b-icon>
                  <span
                    class="is-lowercase "
                    v-if="solution.distanceFromSearchedLocation"
                    >{{ solution.distanceFromSearchedLocation }} miles
                    away</span
                  >
                </a>
              </div>


              <div class="mt-2">
                <a
                  type="is-gant"
                  @click="displayDetails"
                  class="is-size-7 is-block"
                  data-test="hotel_detail_button"
                >
                  View Hotel Details
                </a>
              </div>

          </div>
          <div class="column pr-0 is-narrow-desktop is-one-half-mobile">
            <div class="columns is-mobile">
              <div class="column is-narrow" >
                <PreferredVendorTag v-if="isPreferredVendor" type="hotel"></PreferredVendorTag>

              </div>

              <div class="column is-narrow" v-if="solution.travelPolicy">

                <OutOfPolicyTag
                  position="is-bottom"
                  :travelPolicy="solution.travelPolicy"
                ></OutOfPolicyTag>
              </div>

              <!-- Immediate travel -->
              <div
                v-if="hasImmediateWarning"
                class="column is-narrow"
              >
                <ImmediateTravelNote
                  :severity="hasImmediateWarning"
                ></ImmediateTravelNote>
              </div>
              <!-- End Immediate travel -->

              <div class="column" data-test="price_column">
                <div
                  v-if="this.cheapestPrice > 0"
                  class="is-size-4 has-font-weight-bold has-text-right"
                  data-test="show_price"
                >
                  <p style="margin-top: -10px !important;">
                    ${{ this.cheapestPrice }}
                  </p>
                  <p style="font-size: 10px; color: gray;">
                    per night
                  </p>
                </div>
                <div
                  v-else-if="loading"
                  class="is-size-4 has-font-weight-bold has-text-right"
                  data-test="show_loading"
                >
                  <b-skeleton width="100%" :animated="true"></b-skeleton>
                  <p style="font-size: 10px; color: gray;">
                    per night
                  </p>
                </div>
                <div v-else-if="roomsCount == 0" data-test="show_unavailable">
                  <p style="font-size: 12px; color: gray;">
                    No rooms found for dates selected.
                  </p>
                </div>
              </div>

            </div>

            <div>
              <!-- Mobile Button -->
              <b-button
                class="is-hidden-tablet"
                type="is-primary "
                @click="toggle_rooms"
                expanded
                data-test="submit_button_mobile"
              >
                <strong>
                  {{ buttonContent }}
                </strong>
              </b-button>

              <!-- Desktop Button -->
              <b-button
                class="is-hidden-mobile is-pulled-right"
                type="is-primary is-small"
                @click="toggle_rooms"
                style="margin-top:25px"
                data-test="submit_button_desktop"
              >
                <strong>
                  {{ buttonContent }}
                </strong>
              </b-button>
            </div>

          </div>
        </div>
        <div v-if="display_rooms">
          <div class="container" style="height: 100px;" v-if="!rooms">
            <b-loading :is-full-page="false" :active="true"></b-loading>
          </div>
          <div v-else>
            <HiddenResultsNotification
              v-if="hiddenItemsCount > 0"
              :hiddenItemsCount="hiddenItemsCount"
            >
            </HiddenResultsNotification>

            <div v-if="visibleItemsCount > 0" class="columns ml-3 mt-3">
              <div class="is-size-6 mr-6 mb-4">
                <span class="has-text-primary has-text-weight-bold">{{ visibleItemsCount }}</span> Rates Found
              </div>
              <b-dropdown aria-role="list" class="ml-0 mr-2 mb-2">
                <template #trigger="{ active }">
                  <b-button
                    label="Price"
                    type="is-primary"
                    size="is-small"
                    outlined
                    rounded
                    :icon-right="active ? 'menu-up' : 'menu-down'"
                  />
                </template>

                <b-field
                  :label="'Daily Price: $' + maxPrice[0] + '-$' + maxPrice[1]"
                  style="width: 225px; padding-left: 13px; padding-right: 10px; border: 0 !important;"
                >
                  <b-slider
                    key="price_slider"
                    size="is-small"
                    v-model="maxPrice"
                    :max="1500"
                    :min="cheapestPrice"
                    lazy
                  ></b-slider>
                </b-field>
              </b-dropdown>
              <b-dropdown aria-role="list" class="ml-0 mr-2 mb-2">
                <template #trigger="{ active }">
                  <b-button
                    label="Beds"
                    type="is-primary"
                    size="is-small"
                    outlined
                    rounded
                    :icon-right="active ? 'menu-up' : 'menu-down'"
                  />
                </template>

                <b-field
                  label="Type and Quantity"
                  style="width: 225px; padding-left: 13px; padding-right: 10px; border: 0 !important;"
                >
                  <div class="columns mb-2">
                    <div
                      class="column is-6"
                      style=" width: 100px; padding-bottom: 0px; padding-right: 0px;"
                    >
                      <b-select
                        size="is-small"
                        v-model="bedFilters.type"
                        expanded
                      >
                        <option :value="false">Any</option>
                        <option value="King">Kings</option>
                        <option value="Queen">Queens</option>
                        <option value="Double">Doubles</option>
                      </b-select>
                    </div>
                    <div class="column is-6" style="padding-bottom: 0px;">
                      <b-numberinput
                        v-model="bedFilters.quantity"
                        min="0"
                        max="3"
                        style="width: 90px;"
                        size="is-small"
                        controls-position="compact"
                      ></b-numberinput>
                    </div>
                  </div>
                </b-field>
              </b-dropdown>
              <b-dropdown aria-role="list" class="ml-0 mr-2 mb-2">
                <template #trigger="{ active }">
                  <b-button
                    label="Guarantee Type"
                    type="is-primary"
                    size="is-small"
                    outlined
                    rounded
                    :icon-right="active ? 'menu-up' : 'menu-down'"
                  />
                </template>

                <div
                  class="field"
                  style="width: 275px; padding-left: 13px; padding-right: 10px; border: 0 !important;"
                >
                  <b-radio v-model="guaranteeType" :native-value="false">
                    Any
                  </b-radio>
                  <br />
                  <b-radio
                    v-model="guaranteeType"
                    native-value="GuaranteeRequired"
                  >
                    Guarantee Required
                  </b-radio>
                  <br />
                  <b-radio v-model="guaranteeType" native-value="Deposit">
                    Deposit Required
                  </b-radio>
                  <br />
                  <b-radio v-model="guaranteeType" native-value="PrePay">
                    Non-refundable Pre-pay
                  </b-radio>
                </div>
              </b-dropdown>
              <b-dropdown aria-role="list" class="ml-0 mr-2 mb-2">
                <template #trigger="{ active }">
                  <b-button
                    label="Breakfast"
                    type="is-primary"
                    size="is-small"
                    outlined
                    rounded
                    :icon-right="active ? 'menu-up' : 'menu-down'"
                  />
                </template>

                <div
                  class="field"
                  style="width: 200px; padding-left: 13px; padding-right: 10px; border: 0 !important;"
                >
                  <b-radio v-model="breakfast" :native-value="true">
                    Included
                  </b-radio>
                  <br />
                  <b-radio v-model="breakfast" :native-value="false">
                    No Preference
                  </b-radio>
                </div>
              </b-dropdown>
            </div>
            
            <div v-if="filteredRooms.length == 0" style="padding-bottom: 15px;">
              <b-message type="is-danger" aria-close-label="Close message">
                No results found for these parameters
              </b-message>
            </div>
            <div v-show="filteredRooms.length > 0">
              
              <div v-for="room in filteredRooms" :key="room.key">
                
                <HRoom
                  :room="room"
                  :session="solution.session"
                  @selected="submitted"
                />
               
              </div>
              
            </div>
          </div>
        </div>
      </div>

  </div>
</template>

<script>
let md5 = require("md5");
let moment = require("moment");

import HRoom from "./HRoom";
import GMap from "../../GMap/GMap.vue";
import HotelDetails from "./HotelDetails";
import OutOfPolicyTag from "../../Tags/OutOfPolicyTag.vue";
import HiddenResultsNotification from "../HiddenResultsNotification.vue";
import ImmediateTravelNote from "../../Traveller/ImmediateTravelNote";
import bookingMixin from "@/mixins/bookingMixin";
import meetingsMixin from "@/mixins/meetingsMixin";
import PreferredVendorTag from '../../Tags/PreferredVendorTag.vue';
export default {
  name: "HResult",
  mixins: [bookingMixin, meetingsMixin],
  components: {
    HRoom,
    OutOfPolicyTag,
    PreferredVendorTag,
    HiddenResultsNotification,
    ImmediateTravelNote,
  },
  props: {
    autoloadPrice: Boolean,
    solution: {},
    image: String,
    session: String,
    selected: Boolean,
    roomsProp: Array,
    cheapestPriceProp: {
      required: false,
      type: Number
    },
    filters: Object,
    formData: Object,
    preferredVendors: Array
  },
  data: function() {
    return {
      display_rooms: false,
      loading: false,
      //session: "",
      maxPrice: [0, 1500],
      bedFilters: { type: false, quantity: 0 },
      guaranteeType: false,
      breakfast: false,
      //cheapestPrice: 0,
    };
  },
  computed: {
    
    triptype() {
      return this.$store.state.bookTravel.result.itineraryType;
    },
    buttonContent() {
      let content = "";

      if (!this.display_rooms) {
        if (this.roomsCount > 0) {
          content = "View Room Rates";
        } else {
          content = "View Current Rates";
        }
      } else {
        content = "Hide Room Rates";
      }

      return content;
    },
    cheapestPrice() {
      
      if (this.cheapestPriceProp) {
        return Number(this.cheapestPriceProp.toFixed(0));
      } else {
        return 0;
      }
      
    },
    hiddenItemsCount() {
      var rooms = this.rooms;

      rooms = rooms.filter((i) => {
        return !i.isVisible;
      });

      return rooms.length;
    },
    visibleItemsCount() {
      var rooms = this.rooms;

      rooms = rooms.filter((i) => {
        return i.isVisible;
      });

      return rooms.length;
    },
    rooms() {
      return this.roomsProp;
    },
    roomsCount() {
      return this.rooms?.length;
    },
    filteredRooms() {
      var rooms = this.rooms;
      if (this.breakfast) {
        rooms = rooms.filter((i) => {
          return i.breakfastIncluded;
        });
      }

      rooms = rooms.filter((i) => {
        return (
          i.requestedCurrencyPricing.dailyRate >= this.maxPrice[0] &&
          i.requestedCurrencyPricing.dailyRate <= this.maxPrice[1]
        );
      });

      if (this.bedFilters.type) {
        rooms = rooms.filter((j) => {
          if (!j.description) {
            return false;
          }
          return this.bedFilters.type === j.description.bedType;
        });
      }

      if (this.bedFilters.quantity > 0) {
        rooms = rooms.filter((j) => {
          if (!j.description) {
            return false;
          }
          return this.bedFilters.quantity <= j.description.bedNum;
        });
      }

      if (this.guaranteeType) {
        if (this.guaranteeType == "PrePay") {
          rooms = rooms.filter((j) => {
            return (
              j.enhancedPricing.guaranteeType == "Deposit" && j.nonrefundable
            );
          });
        } else if (this.guaranteeType == "Deposit") {
          rooms = rooms.filter((j) => {
            return (
              j.enhancedPricing.guaranteeType == "Deposit" && !j.nonrefundable
            );
          });
        } else {
          rooms = rooms.filter((j) => {
            return j.enhancedPricing.guaranteeType == this.guaranteeType;
          });
        }
      }


      return rooms;
    },
    hasImmediateWarning(){
      let hasWarning = null;

      if(this.rooms && this.rooms.length > 0) {
        for (let room in this.rooms) {
          if (room.immediateTravelBookingAdvice !== '') {
            hasWarning = this.rooms[room].immediateTravelBookingAdvice;
          }
        }
      }

      return hasWarning;
    },
    isPreferredVendor(){
      return this.solution.isPreferred;
      // return this.preferredVendors.includes(this.solution.chainCode);
    } 
  },
  methods: {
    imageModal() {
      const h = this.$createElement;
      const vnode = h(
        "p",
        { class: "image", style: "width: 300px; height: 300px;" },
        [h("img", { attrs: { src: this.image } })]
      );
      this.$buefy.modal.open({
        content: [vnode],
      });
    },
    submitted(value) {
      this.$store.dispatch("bookTravel/alterHotelResult", {});
      value.checkinDate = value.startDate;
      value.checkoutDate = value.endDate;
      value.hotelName = this.$helpers.capitalize(this.solution.hotelName);
      value.hotelCity = this.solution.address.CityName;
      value.chainName = this.$helpers.capitalize(this.solution.chainName);
      value.image = this.image;
      value.position = {
        lat: this.solution.geocode.Latitude / 100000,
        lng: this.solution.geocode.Longitude / 100000,
      };
      value.address = this.solution.address.AddressLine;
      value.session = this.solution.session;


      this.$store.dispatch("bookTravel/alterHotelResult", value);


      if (this.pathMixin_isMeeting) {
        this.goToNextStep("cars");
      } else {
        this.$nav.pushRouteTo({ name: "BookingItinerary" });
      }
    },
    show_rooms(){
      this.display_rooms = true;
    },
    toggle_rooms() {
      this.display_rooms = !this.display_rooms;
      if (!this.rooms) {
       // console.log('call getLiveRates()');
        this.getLiveRates();
      }
    },
    //get live room rates and availabilty for the current hotel
    getLiveRates() {
      this.loading = true;
      // Find applicable traveler program rate codes for the traveler
      let allPrograms = this.$store.getters[
        "travellersAndTrips/getCurrentTravellerProfile"
      ].travelerPrograms;
      
      let hotelPrograms = allPrograms;

      let hotelChainCode = this.solution.chainCode;

      // Filter the programs
      hotelPrograms = hotelPrograms.filter((item) => {
        return (
          item.rateCode != null &&
          item.type == "Hotel" &&
          (item.providerCode == hotelChainCode ||
            item.relatedProviderCodes.includes(hotelChainCode))
        );
      });

      // Make list of applicable rate codes
      let rateCodes = [];

      for (let hotelProgram of hotelPrograms) {
        // Skip if we already have this rate code set
        if (rateCodes.includes(hotelProgram.rateCode)) continue;

        rateCodes.push(hotelProgram.rateCode);
      }


      let body = {
        stateful: true,
        sessionKey: this.session ?? null,
        requestedCurrency: "USD",
        normalizeResponse: true,
        travelerContactId: this.$store.getters[
          "travellersAndTrips/getCurrentTravellerProfile"
        ].id,
        travelPolicyId: this.$store.getters[
          "travellersAndTrips/getCurrentTravellerProfile"
        ].travelPolicyId,
        hotelCode: this.solution.hotelCode,
        checkInDate: moment(this.formData.checkinDate).format(
          "YYYY-MM-DD"
        ),
        checkOutDate: moment(this.formData.checkoutDate).format(
          "YYYY-MM-DD"
        ),
        roomCount: 1,
        guestCount: 1,
        ratePlanCodes: rateCodes,
      };

      this.$app
        .huddleLabsServerCall("amadeus/hotel/live-search", body)
        .then((result) => {

          let payload = { 
            data: result.data, 
            hotelCode: this.solution.hotelCode, 
            session: result.meta?.sessionKey 
          };

          this.$emit("setLiveData", payload);
          this.loading = false;
        });
    },
    /*
    sendRooms(rooms) {
      var val = { rooms: rooms, hotel: this.solution.hotelCode };
      this.$emit("setRooms", val);
    },
    */
    displayDetails() {
      var details = {
        parent: this,
        component: HotelDetails,
        props: {
          hotelCode: this.solution.hotelCode,
          location: this.solution.geocode,
          width: "700",
          height: "500",
          image: this.image,
        },
        hasModalCard: true,
        trapFocus: true,
        width: 700,
      };
      // console.log('opening')
      this.$buefy.modal.open(details);
    },
    flightSelected() {
      if (this.triptype == 0) {
        this.$store.dispatch("bookTravel/alterResult", this.result);
        this.$router.push({ path: "/summary" });
      } else if (this.triptype == 1 && this.first_selected) {
        this.$store.dispatch("alterSecondLeg", this.result);
        this.$router.push({ path: "/summary" });
      } else if (this.triptype == 1) {
        // console.log('testing')
        this.$store.dispatch("bookTravel/alterResult", this.result);
        this.$emit("selected");
      }
    },
    goToMaps(lat, long) {
      // console.log('tried')
      var details = {
        parent: this,
        component: GMap,
        props: {
          lat: lat,
          long: long,
          width: "700",
          height: "600",
          image: this.image,
        },
        hasModalCard: true,
        trapFocus: true,
        width: 700,
      };
      this.$buefy.modal.open(details);
    },
  },
  watch: {
    autoloadPrice() {
      if (this.autoloadPrice == true) {
        this.getLiveRates();
      }
    },
  },
  mounted() {
    if (this.autoloadPrice && this.rooms == null) {
      this.getLiveRates();
    }

    if (this.selected) {
      this.show_rooms();
    }
  },
};
</script>

<style scoped></style>
